import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
const buyers = [{
  name: 'Patrizia',
  city: 'Milano'
}, {
  name: 'Giuseppe',
  city: 'Roma'
}, {
  name: 'Antonella',
  city: 'Napoli'
}, {
  name: 'Roberto',
  city: 'Torino'
}, {
  name: 'Sabrina',
  city: 'Bologna'
}, {
  name: 'Marco',
  city: 'Firenze'
}, {
  name: 'Chiara',
  city: 'Palermo'
}, {
  name: 'Federica',
  city: 'Genova'
}, {
  name: 'Luca',
  city: 'Bari'
}, {
  name: 'Elena',
  city: 'Verona'
}, {
  name: 'Stefano',
  city: 'Catania'
}, {
  name: 'Maria',
  city: 'Padova'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  const [timeAgo, setTimeAgo] = useState(2);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showNextBuyer();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextBuyer = () => {
    const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
    const randomTime = Math.floor(Math.random() * 15) + 1;
    setCurrentBuyer(randomBuyer);
    setTimeAgo(randomTime);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        showNextBuyer();
      }, Math.random() * 8000 + 12000);
    }, 6000);
  };
  return <AnimatePresence data-id="element-228">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -50,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -50,
      scale: 0.9
    }} className="fixed bottom-24 left-3 sm:bottom-28 sm:left-6 z-50 max-w-[270px] w-[calc(100%-1.5rem)]" data-id="element-229">
          <div className="bg-gradient-to-br from-brand-card to-[#2a1810] border-2 border-brand-gold rounded-xl p-3 shadow-[0_0_25px_rgba(251,191,36,0.45)] relative overflow-hidden" data-id="element-230">
            <div className="absolute top-0 left-0 w-full h-[3px] bg-gradient-to-r from-brand-orange via-brand-gold to-brand-orange" data-id="element-231" />

            <button onClick={() => setIsVisible(false)} className="absolute top-1.5 right-1.5 text-gray-500 hover:text-white" aria-label="Chiudi" data-id="element-232">
              <XIcon className="w-3.5 h-3.5" data-id="element-233" />
            </button>

            <div className="flex items-center gap-2.5" data-id="element-234">
              <div className="w-9 h-9 rounded-full bg-gradient-to-br from-brand-orange to-brand-gold flex items-center justify-center text-black font-black text-base shrink-0 shadow-[0_0_10px_rgba(249,115,22,0.5)]" data-id="element-235">
                {currentBuyer.name.charAt(0)}
              </div>
              <div className="min-w-0" data-id="element-236">
                <p className="text-[12px] text-gray-200 font-medium leading-snug" data-id="element-237">
                  <span className="font-black text-brand-cream" data-id="element-238">
                    {currentBuyer.name}
                  </span>{' '}
                  da{' '}
                  <span className="text-brand-gold font-bold" data-id="element-239">
                    {currentBuyer.city}
                  </span>{' '}
                  ha appena acquistato{' '}
                  <span className="font-bold text-brand-orange" data-id="element-240">
                    ECONOMIA PRO™
                  </span>
                </p>
                <div className="flex items-center gap-2 mt-0.5" data-id="element-241">
                  <span className="flex items-center gap-1 text-[10px] text-green-400 font-bold" data-id="element-242">
                    <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse" data-id="element-243" />
                    Verificato
                  </span>
                  <span className="text-[10px] text-gray-500" data-id="element-244">
                    {timeAgo} min fa
                  </span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}